export class CandidateVerificationStatus {
    id: number;
    description: string;

    private constructor(id: number, description: string) {
        this.id = id;
        this.description = description;
    }

    public static Awaiting = new CandidateVerificationStatus(10, "Awaiting");
    public static Verified = new CandidateVerificationStatus(20, "Verified");
    public static Denied = new CandidateVerificationStatus(30, "Denied");

    public static asArray = () => [
        CandidateVerificationStatus.Awaiting,
        CandidateVerificationStatus.Verified,
        CandidateVerificationStatus.Denied,
    ];

    public static fromId = (id: number) => {
        if (id === undefined) return undefined;
        const status = CandidateVerificationStatus.asArray().find(
            s => s.id === id
        );
        return status;
    };
}
